import axios from 'axios'

export default {
    getInvoices: () => axios.post('dashboard/invoices'),
    getAmountInvoices: () => axios.post('dashboard/invoices/amount'),
    getAverageInvoices: () => axios.post('dashboard/invoices/avg'),
    getPayments: () => axios.post('dashboard/payments'),
    getGraph: () => axios.post('dashboard/graph')
}